import { useRouter } from 'next/router';
import { HTMLAttributes, PropsWithChildren } from 'react';

import useLogout from '~hooks/useLogout';
import useHeaderStore from '~store/header';

import { GnbMenu } from '../constants';
import * as S from './style';

interface Props extends Omit<GnbMenu, 'id' | 'label'>, HTMLAttributes<HTMLAnchorElement> {
  gnbId: string;
  gnbKind: string;
  href?: string;
  target?: string;
  isNew?: boolean;
  onClick?: () => void;
}

export default function GnbItem({
  gnbId,
  href,
  gnbKind,
  children,
  target,
  onClick,
  ...props
}: PropsWithChildren<Props>) {
  const router = useRouter();
  const { setIsModalBookmarksOpen, setIsModalCompanyListOpen } = useHeaderStore();
  const handleLogout = useLogout();
  const defaultProps = {
    'data-attribute-id': 'gnb',
    'data-gnb-kind': gnbKind,
    target,
  };
  const handleClick = () => {
    if (href && target !== '_blank') {
      router.push(href);
    }

    switch (gnbId) {
      case 'companylist':
        setIsModalCompanyListOpen(true);
        break;
      case 'bookmark':
        setIsModalBookmarksOpen(true);
        break;
      case 'logout':
        handleLogout({ reload: true });
        break;
      default:
        break;
    }

    if (onClick) {
      onClick();
    }
  };

  return (
    <S.Anchor {...defaultProps} {...props} onClick={handleClick}>
      {children}
    </S.Anchor>
  );
}
